const initialState = {
  contentApi: process.env.CLIENT_CONTENT_API_URL,
  canonicalUrlBase: process.env.CANONICAL_URL_BASE
}

const config = (state = initialState) => state

export default config
